// extracted by mini-css-extract-plugin
module.exports = {"role":"style_role__1c6mf"};